module.exports = __webpack_public_path__ + "img/fb06.dad7b7da.jpg";